import { render, staticRenderFns } from "./inviteJob.vue?vue&type=template&id=353e7faa&scoped=true"
import script from "./inviteJob.vue?vue&type=script&lang=js"
export * from "./inviteJob.vue?vue&type=script&lang=js"
import style0 from "./inviteJob.vue?vue&type=style&index=0&id=353e7faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e7faa",
  null
  
)

export default component.exports